import detailDefault from '../../detailDefault';

export default class detailaon_portal_messages extends detailDefault {
    load(sAction, data) {
        // call immediately after detailView is load
        this.sendToEveryoneUpdate(sAction, data.prefix, sAction.dataGet(data.prefix + '/fields/send_to_everyone/value'));
    }
    update(sAction, data) {
        // call immediately after detailView field is update
        if (data.field === 'send_to_everyone') {
            this.sendToEveryoneUpdate(sAction, data.prefix, data.value);
        }
    }

    // disable Require Reading if Send to Everyone is checked
    sendToEveryoneUpdate(sAction, prefix, value) {
        sAction.dsClear();
        sAction.dsAdd('set', prefix + '/fields/require_reading/def/readonly', value);
        if (value) {
            sAction.dsAdd('set', prefix + '/fields/require_reading/value', 0);
            sAction.dsAdd('set', prefix + '/changes/fields/require_reading', 0);
        }
        sAction.dsProcess();
    }
}
